module.exports = {"532926101":"南涧镇","532926102":"小湾东镇","532926103":"公郎镇","532926104":"宝华镇","532926105":"无量山镇","532926201":"拥翠乡","532926202":"乐秋乡","532926203":"碧溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532926.json
// module id = 2462
// module chunks = 0